import { render, staticRenderFns } from "./LabelsTab.vue?vue&type=template&id=39dbf4a8"
import script from "./LabelsTab.vue?vue&type=script&lang=ts"
export * from "./LabelsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports